import React from "react";
import ConversionPage from "@/components/ConversionPage";

export default function FoundationsYouthPage() {
  return (
    <ConversionPage
      accentColor="blue"
      badge="Foundations  |  Youth Athletes  |  Ages 10-18"
      headline={<>THE STARTING LINE<br />ISN'T A LIMITATION.<br /><span className="text-blue-400">IT'S AN ADVANTAGE.</span></>}
      subheadline="Most young athletes skip the fundamentals and wonder why they plateau. Foundations teaches your body how to move, load, and recover the right way — so when it's time to compete, you're already ahead. Just 2 sessions a week. That's all it takes."
      heroImage="https://images.unsplash.com/photo-1639653816939-22fc6b8a955b?auto=format&fit=crop&w=1920&q=80"
      painPoints={[
        "Your coach says \"get stronger\" but no one teaches you how to actually lift.",
        "You see other athletes pulling ahead and don't know what they're doing differently.",
        "You tried following a program online but it wasn't designed for someone your age.",
      ]}
      featureTitle="What's Inside Foundations"
      features={[
        { title: "2 Sessions Per Week", desc: "Designed to fit around school and practice. Two focused sessions that build real strength without burnout." },
        { title: "Movement Mastery", desc: "Squat, hinge, press, pull — learn the patterns that every great athlete is built on." },
        { title: "Age-Appropriate Progressions", desc: "Programs designed for developing bodies. No shortcuts, no risk, just smart training." },
        { title: "Injury Prevention", desc: "Every session includes mobility and prehab work to keep you healthy all season." },
        { title: "Progress Tracking", desc: "See your lifts go up week over week. Know exactly where you stand." },
        { title: "Exercise Video Library", desc: "Watch proper form cues for every movement before you touch the bar." },
      ]}
      testimonial={{
        quote: "Results speak louder than anything. The athletes on this program consistently outperform their peers.",
        name: "Paladin Coaching Staff",
        detail: "Based on assessment data from 500+ youth athletes",
      }}
      price="$20"
      priceInterval="week"
      priceCta="Start Foundations"
      priceTier="foundations"
      faqs={[
        { q: "What age is this for?", a: "Foundations is designed for athletes ages 10-18. The programming scales to your experience level — whether you've never touched a barbell or you've been training for a year." },
        { q: "Do I need a gym membership?", a: "Yes, you'll need access to basic gym equipment: a barbell, dumbbells, and a squat rack. Most school weight rooms and commercial gyms have everything you need." },
        { q: "How many days per week?", a: "Just 2 sessions per week, about 45-60 minutes each. It's designed to fit around school and practice — no more, no less." },
        { q: "Can I cancel anytime?", a: "Absolutely. No contracts, no commitments. Cancel your subscription anytime from your dashboard." },
      ]}
      backPath="/foundations"
    />
  );
}
